import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset link is invalid or has expired");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="sv-overline mb-3 text-center">Set New Password</div>
        <h1 className="font-serif-hero text-4xl text-center text-[#F4E4BC]">Choose a new password</h1>
        {!token ? (
          <div className="mt-10 sv-card p-6 text-center">
            <div className="text-sm text-[#CDC7BA]">This link is missing or malformed.</div>
            <Link to="/forgot-password" className="inline-block mt-6 sv-btn-outline text-xs">Request a new link</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-4">
            <input data-testid="reset-password" required type="password" placeholder="New password (min 8 chars)"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl focus:border-[#C5A059] outline-none" />
            <input data-testid="reset-confirm" required type="password" placeholder="Confirm password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl focus:border-[#C5A059] outline-none" />
            <button data-testid="reset-submit" disabled={busy} className="sv-btn-primary w-full">
              {busy ? "Updating…" : "Update Password"}
            </button>
          </form>
        )}
      </div>
      <Footer />
    </div>
  );
}
